"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepeatVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _conditions = require("../../conditions");
class RepeatVariable {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", {});
    (0, _defineProperty2.default)(this, "type", "repeat");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "label", "Repeat");
  }
  dependencies(params, resolver) {
    let items = resolver.resolveArray(params.items);
    return {
      items,
      filter: (0, _conditions.resolveConditionsForFilter)(params.filter, resolver)
    };
  }
  getValue(ref, deps, batcher) {
    if (deps !== null && deps !== void 0 && deps.items) {
      var _items;
      let {
        items,
        filter
      } = deps;
      if (filter) {
        items = items.filter(value => (0, _conditions.testConditions)(filter, value));
      }
      if (((_items = items) === null || _items === void 0 ? void 0 : _items.length) > 0) {
        ref.value = items;
        return;
      }
    }
    ref.value = [null];
  }
}
exports.RepeatVariable = RepeatVariable;
//# sourceMappingURL=RepeatVariable.js.map